import dayjs from "dayjs";

const utc = require("dayjs/plugin/utc");

dayjs.extend(utc);

/**
 * @param {object} params
 * @param {string} params.localDate
 * @return {string}
 */
export default function convertPublishDateToUtc({ localDate }) {
  return dayjs(localDate).utc().format("YYYY-MM-DD HH:mm");
}
